import type { AvailableSubscription } from "../api/availableSubscription";
import {
	type AgreementJson,
	getValidAgreementJson,
	parseSubTypeId,
	type SubTypeId,
} from "./Agreement";

export interface Company {
	id: string;
	name: string;
	agreementId: string;
	invoiceReference: string;
	widgetPolicy: "create" | "request";
	ticketOwnerFieldName: string;
	subTypeId: SubTypeId;
}

export interface CompanyWithAvailableSubscriptions extends Company {
	availableSubscriptions: AvailableSubscription[];
	hasTravelSubscription: boolean;
}

export interface CompanyJson {
	id: string;
	name: string;
	agreements: AgreementJson[];
}

export const mapCompany = (json: CompanyJson): Company => {
	const agreement = json.agreements.find(
		(agreement) =>
			(agreement.subTypeId === "SUBSCRIPTIONS" ||
				agreement.subTypeId === "HOUSING_COOPERATIVE_AGREEMENT") &&
			(agreement.settings.widgetAccess === "ALLOW_TICKET_REQUESTS" ||
				agreement.settings.widgetAccess === "ALLOW_TICKET_CREATION"),
	);
	if (!agreement) throw new Error("Found no company with correct agreement");

	const widgetPolicy =
		agreement.settings.widgetAccess === "ALLOW_TICKET_CREATION"
			? "create"
			: "request";

	return {
		agreementId: agreement?.id,
		id: json.id,
		invoiceReference: agreement.invoiceReference,
		name: json.name,
		ticketOwnerFieldName: agreement.settings.employeeIdLabel,
		widgetPolicy,
		subTypeId: parseSubTypeId(agreement.subTypeId),
	};
};

export const getValidCompanyJson = ({
	id = "1226629",
	name = "Unibuss",
	subTypeId = "SUBSCRIPTIONS",
	widgetAccess = "ALLOW_TICKET_REQUESTS",
	employeeIdLabel = "Ansattnr.",
} = {}): CompanyJson => ({
	id,
	name,
	agreements: [
		getValidAgreementJson({
			id: `ag-${id}`,
			subTypeId,
			widgetAccess,
			employeeIdLabel,
		}),
	],
});
